<template>
	<v-container fluid>
		<v-row>
			<v-col cols="11">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
			</v-col>
			<v-col cols="1">
				<export-excel :items="items" :headers="headers" :fileName="excelFileName">
				</export-excel>
			</v-col>
			<v-col cols="12">
				<v-data-table :height="dataTableFixedHeight - 100" fixed-header :headers="headers" :loading="loading" :items="items" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td @click="manageLoans(row.item)" style="cursor: pointer;">
								{{ row.item.loanModel.title }}
								<div class="grey--text">شماره وام: {{ row.item.code }}</div>
							</td>
							<td class="text-center">
								{{ row.item.amount.toString().toPriceFormat() }}
							</td>
							<td @click="manageLoans(row.item)" style="cursor: pointer;">
								{{ row.item.memberModel.fullName }}
								<div class="grey--text">کد ملی: {{ row.item.memberModel.nationalCode }}</div>
							</td>
							<td @click="manageRequest(row.item.userLoanRequest)" style="cursor: pointer;">
								<div v-if="row.item.userLoanRequest">
									شماره: {{ row.item.userLoanRequest.code }}
									<div class="grey--text">تاریخ درخواست: {{ row.item.userLoanRequest.requestDate_Persian.date }}</div>
									<div class="grey--text">نماینده: {{ row.item.userLoanRequest.agentModel ? row.item.userLoanRequest.agentModel.businessName : 'ندارد' }}</div>
								</div>
							</td>
							<td class="text-center">
								{{ row.item.depositChargeDueDate_Persian.date }}
							</td>
							<td class="text-center">
								{{ row.item.chargeTypeTitle || row.item.str_ChargeType }}
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-col>
		</v-row>

		<v-dialog v-model="dialogLoansManager" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogLoansManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<manage-loan ref="manageLoan" v-if="dialogLoansManager" :data="{ member: selectedMember }" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogUserLoanRequest" scrollable persistent max-width="1100px">
			<modify-request ref="modifyRequest" v-if="dialogUserLoanRequest" :data="selectedRequest" @callbck="callbck" @close="dialogUserLoanRequest = false" />
		</v-dialog>

	</v-container>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

export default {
	name: 'DepositChargeOverDue',
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
		'date-picker': VuePersianDatetimePicker,
		'modify-request': () => import('../ModifyLoanRequest.vue'),
		'manage-loan': () => import('@/views/admin/ManageLoan.vue'),
	},
	data() {
		return {
			errorMessages: '',
			search: '',
			selectedMember: {},
			selectedRequest: {},
			loading: false,
			dialogLoansManager: false,
			dialogUserLoanRequest: false,
			items: [],
			headers: [
				{
					text: 'مشخصات وام',
					align: 'start',
					sortable: true,
					value: 'loanModel.title',
				}, {
					text: 'مبلغ وام',
					align: 'center',
					sortable: true,
					value: 'amount',
				}, {
					text: 'مشخصات مشتری',
					align: 'start',
					sortable: true,
					value: 'memberModel.fullName',
				}, {
					text: 'کد ملی',
					align: 'center d-none',
					sortable: true,
					value: 'memberModel.nationalCode',
				}, {
					text: 'مشخصات درخواست',
					align: 'center',
					sortable: true,
					value: 'userLoanRequest',
				}, {
					text: 'سررسید واریز به مشتری',
					align: 'center',
					sortable: true,
					value: 'depositChargeDueDate_Persian',
					excel_value: 'depositChargeDueDate_Persian.date',
				}, {
					text: 'نحوه دریافت',
					align: 'center',
					sortable: true,
					value: 'str_ChargeType',
					width: 120
				}
			]
		}
	},
	computed: {
		excelFileName() {
			let name = 'لیست سررسید های مشتریان'
			name += '.xls'
			return name
		},
	},
	mounted() {
		this.loadData()
	},
	methods: {
		loadData() {
			this.loading = true
			api.get('admin/UserLoan/GetDepositChargeDueDate/true', {})
				.then(
					response => {
						this.items = response.items
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => { this.loading = false })
		},
		manageLoans(item) {
			this.selectedMember = { id: item.memberModel.id, fullName: item.memberModel.fullName, nationalCode: item.memberModel.nationalCode, mobile: item.memberModel.mobile }
			this.dialogLoansManager = true
		},
		manageRequest(loanRequests) {
			if (!loanRequests)
				return
			this.selectedRequest = loanRequests
			this.dialogUserLoanRequest = true
		},
		callbck(result) {
			if (result) {
				this.loadData()
			}
		},
	},
}
</script>
<style></style>
